import { getVar } from '../utils/environment';
export class SsoService {
    commonService;
    constructor(commonService) {
        this.commonService = commonService;
    }
    getSsoProfileParams() {
        return {
            email: getVar('email'),
            mobile: getVar('mobile'),
            name: getVar('name'),
            oaType: getVar('oaType'),
            emailRequired: getVar('emailRequired') === 'true',
            identifierRequired: getVar('identifierRequired') === 'true',
            code: getVar('code'),
            corp_id: getVar('corp_id'),
            agent_id: getVar('agent_id'),
            app_id: getVar('app_id'),
        };
    }
}
